import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Page } from '@dixa/lib-shared-habla';
import { ExportConversationsBanner } from './components/banner/exportConversationsBanner';
import { ExportConversationsForm } from './components/form/exportConversationsForm';
export const SettingsExportConversationsView = () => {
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "Export conversations" }), _jsx(Page.Body, { children: _jsx(Page.Section, Object.assign({ callout: _jsx(ExportConversationsBanner, {}) }, { children: _jsx(ExportConversationsForm, {}) })) })] }));
};
